import type { Locale } from './locales'
import type { Messages } from './fa'
import fa from './fa'
import en from './en'
import de from './de'
import ar from './ar'

export * from './locales'
export type { Messages }

export const dictionaries: Record<Locale, Messages> = { fa, en, de, ar }

type Primitive = string | number | boolean | null | undefined

/** Resolve a dotted key like `home.tiles.wallet.title` from nested messages. */
export function translate(
  messages: Messages,
  key: string,
  vars?: Record<string, Primitive>,
): string {
  const parts = key.split('.')
  let cur: unknown = messages
  for (const part of parts) {
    if (cur && typeof cur === 'object' && part in (cur as object)) {
      cur = (cur as Record<string, unknown>)[part]
    } else {
      return key
    }
  }
  if (typeof cur !== 'string') return key
  if (!vars) return cur
  return cur.replace(/\{(\w+)\}/g, (_, name: string) => {
    const v = vars[name]
    return v == null ? `{${name}}` : String(v)
  })
}
